/* eslint no-unused-vars: 0 */

import React from "react"

class AdminSearchPromotionResult extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      position: props.result.position || "",
      original_position: props.result.position || "",
      delete: false,
      result: props.result
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.handlePosition = this.handlePosition.bind(this);
    this.checkPosition = this.checkPosition.bind(this);
  }

  componentDidMount() {
    this.checkPosition();
  }

  checkPosition() {
    this.props.current_priority_list.filter(option => {
      if (option.product_id === this.state.result.step_id) {
        this.setState({ position: option.position });
      }
    });
  }

  handlePosition(e) {
    if (isNaN(e.target.value) === false) {
      this.setState(
        {
          position: e.target.value
        },
        () => {
          this.props.position(this.state.result.step_id, this.state.position);
        }
      );
    }
  }

  handleDelete() {
    this.setState(
      {
        delete: !this.state.delete
      },
      () => {
        this.props.delete(this.state.result.step_id);
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      position: nextProps.result.position || "",
      original_position: nextProps.result.position || "",
      delete: false,
      result: nextProps.result
    });
  }

  render() {
    var image =
      this.state.result.promoted === true ? <i className="icon-ok" /> : "";
    var remove =
      this.state.result.promoted === true ? (
        <input
          type="checkbox"
          onChange={this.handleDelete}
          checked={this.state.delete}
        />
      ) : (
        ""
      );
    var part_code =
      this.props.selected_mode === "Product" ? (
        <td>{this.state.result.part_code}</td>
      ) : null;
    var stock_code =
      this.props.selected_mode === "Product" ? (
        <td>{this.state.result.stock_code}</td>
      ) : null;

    var brand_image =
      this.state.result.brand_image !== null ? (
        <img
          src={this.state.result.brand_image}
          className="pull-right brand-image"
        />
      ) : null;
    return (
      <tr
        key={this.state.result.step_id}
        className={
          (this.state.result.promoted === true ? " promoted " : "") +
          (this.state.delete === true ? " delete " : "") +
          (this.state.position !== this.state.original_position
            ? " modified "
            : "")
        }
      >
        <td>
          <input
            type="text"
            onChange={this.handlePosition}
            value={this.state.position}
          />
        </td>
        <td>{this.state.result.step_id}</td>
        <td>
          <img src={this.state.result.image_small} />{" "}
          {this.state.result.description_short}{" "}
          {brand_image}
        </td>
        {part_code}
        {stock_code}
        <td className="promotion">{image}</td>
        <td>{remove}</td>
      </tr>
    );
  }
}

export default AdminSearchPromotionResult;
